import {db} from './firebase-connect'

const submitComment = (msg) => {
    let tx = db.ref('comments/').push({
        msg : msg
    })
    return tx;
}

function snapshotToArray(snapshot) {
    var returnArr = [];

    snapshot.forEach(function(childSnapshot) {
        var item = childSnapshot.val();
        item.key = childSnapshot.key;

        returnArr.unshift(item);
    });

    return returnArr;
};

const submitNewProp = async (name, developer, bathroom, restroom, propType, lat, lng, propScale, properties, nearestProp,
    prop_img, province, interestPercen, rating, maxInvestor, propAmount, detail, postDate, propFinishDate, propWebsite) => {
   let tx = db.ref('properties/').push({
       name : name,
       developer : developer,
       bathroom : bathroom,
       restroom : restroom,
       propType : propType,
       nearestProp : nearestProp,
       properties : properties,
       prop_img : prop_img,
       lat : lat,
       lng : lng,
       propScale : propScale,
       province : province,
       interestPercen : interestPercen,
       rating : rating,
       maxInvestor : maxInvestor,
       propAmount : propAmount,
       detail : detail,
       postDate : postDate,
       propFinishDate : propFinishDate,
       propWebsite : propWebsite,
       status : false,
       views : 0
       })
   return tx

  }

const submitNewInvest = (propID, initDate, minInvestAmount, earnestAmount, maxInvestor,
    initInvestName, initInvestEmail, initInvestTel, investFinishDate) => {

   let tx = db.ref("investGroupList/"+propID).push({
        initDate : initDate,
        minInvestAmount : minInvestAmount,
        maxInvestor : maxInvestor,
        minInvestAmount : minInvestAmount,
        earnestAmount : earnestAmount,
        initInvestName : initInvestName,
        initInvestEmail : initInvestEmail,
        initInvestTel : initInvestTel,
        investFinishDate : investFinishDate,
        numInvestors : 1,
        views : 0,
        propID : propID,
        status : false
   })
   return tx;
  }

  const submitJoinInvest = (propID,investGroupID, joinDate, investorName, investorEmail, investorTel) => {
      let tx
    getInvestGroupInfo(propID, investGroupID).then((res,err) => {
        if(!err){
            if(res.numInvestors < res.maxInvestor){
                let _updates = {}
                _updates["\"numInvestors\" :"+res.numInvestors+1]
                db.ref("/investGroupList/"+propID+"/"+investGroupID+"/").update({'numInvestors': res.numInvestors+1})
                    .then(() => {
                        tx = db.ref('joinList/'+propID+"/"+investGroupID).push({
                            investorName : investorName,
                            investorEmail : investorEmail,
                            investorTel : investorTel,
                            joinDate : joinDate,
                            groupID : investGroupID,
                            propID : propID
                        })
                })
            } else {
                console.log('This project already done')
            }
        }
        }).then(() => {
            return tx
        })
  }

  const getInvestGroupList = async(propID) => {
    return new Promise((resolve) => {
        db.ref('investGroupList/'+propID).on('value', (snapshot,err) => {
            if(!err){
                resolve(snapshot.val())
            }
           else {
               resolve('')
           }
        })
    })
  }

const getProperties = async() => {
    return new Promise((resolve) => {
        db.ref("properties/").on('value', (snapshot,err) => {
          if (!err) {
                let resArr = snapshotToArray(snapshot);
                resolve(resArr);
            }
           else {
               resolve('')
           }
        })
    })
}

const getPropertiesInvestGroup = async() => {

    return new Promise( (resolve) => {
      db.ref("investGroupList/").on('value', (snapshot,err) => {
        if(!err){
              let resArr = snapshotToArray(snapshot);
              resolve(resArr);
        }
        else {
          resolve('')
        }
      })
    })
  }

const getPropertyInfo = async (propID) => {
    return new Promise((resolve) => {
        db.ref("properties"+'/'+propID).on('value', (snapshot,err) => {
            if(!err){
                resolve(snapshot.val())
            }
           else {
               resolve('')
           }
        })
    })
}

const getInvestGroupInfo = async(propID, investGroupID) => {
    return new Promise((resolve) => {
      db.ref('investGroupList/'+propID+"/"+investGroupID).on('value', (snapshot,err) => {
          if(!err){
              resolve(snapshot.val())
          }
         else {
             resolve('')
         }
      })
  })
  }

const _getVisitHomeView = async () => {
    return new Promise((resolve) => {
        db.ref("index/homepage").on('value', (snap,err) => {
            if(!err){
                resolve(snap.val())
            }
            else {
                resolve('')
            }
        })
    })
}

const _getVisitIntroView = async () => {
    return new Promise((resolve) => {
        db.ref("index/intropage").on('value', (snap,err) => {
            if(!err){
                resolve(snap.val())
            }
            else {
                resolve('')
            }
        })
    })
}

const increasePropView = async(propID) => {
    getPropertyInfo(propID).then((res,err) => {
      let _updates = {}
      _updates["\"views\" :"+res.views+1]
      db.ref('properties/'+propID).update({'views': res.views+1})
    })
  }

  const increaseInvestGroupView = async(propID,investGroupID) => {
    getInvestGroupInfo(propID, investGroupID).then((res,err) => {
      let _updates = {}
      _updates["\"views\" :"+res.views+1]
      db.ref("investGroupList/"+propID+"/"+investGroupID+"/").update({'views': res.views+1})
    })
  }

  const increaseVisitHome = async() => {
    _getVisitHomeView().then((res,err) => {
        let _updates = {}
        _updates["\"views\" :"+res.views+1]
        db.ref("index/homepage").update({'views': res.views+1})
      })
  }

  const increaseVisitIntro = async() => {
    _getVisitIntroView().then((res,err) => {
        let _updates = {}
        _updates["\"views\" :"+res.views+1]
        db.ref("index/intropage").update({'views': res.views+1})
      })
  }

export {submitComment, submitNewProp, getInvestGroupInfo, submitNewInvest,
    submitJoinInvest, getProperties, getPropertiesInvestGroup, getPropertyInfo,
    getInvestGroupList, increasePropView, increaseInvestGroupView,
     increaseVisitHome, increaseVisitIntro}
